import React from "react";
import { SectionHeading } from "../SectionHeading";
import { TransformCTA } from "../TransformCTA";
import { challenges } from "../../data/content";
export function Challenges() {
  return <section className="bg-white px-4 py-16 sm:py-24" data-id="element-148" data-mp="2cz79zh0x2ovv">
      <div className="mx-auto max-w-6xl" data-id="element-149" data-mp="2cwl3lkpriff8">
        <SectionHeading kicker="Does any of this sound familiar?" title="6 professional challenges this collection was designed to address" intro={["If you work with aesthetic laser technologies, you may recognize some of these situations."]} data-id="element-150" data-mp="2hx8r3wes8e4p" />

        <ol className="mt-12 grid gap-x-12 md:grid-cols-2" data-id="element-151" data-mp="1tztf8wvd5a4b">
          {challenges.map((c, i) => <li key={c.title} className="flex gap-4 border-t border-navy-900/10 py-8 sm:gap-6" data-id="element-152" data-mp="1yymr6kv04t2d" data-mpi={i}>
              <span className="font-display text-5xl font-extrabold leading-none text-electric sm:text-6xl" aria-hidden="true" data-id="element-153" data-mp="3oduj5w5rsnb9">
                {i + 1}
              </span>
              <div data-id="element-154" data-mp="3taur6cm6k050">
                <h3 className="font-display text-2xl font-bold uppercase leading-tight text-ink" data-id="element-155" data-mp="xcdxjsc7p6e0">{c.title}</h3>
                <div className="mt-3 space-y-2 text-base text-muted" data-id="element-156" data-mp="tb23namb1z00">
                  {c.body.map(p => <p key={p} data-id="element-157" data-mp="172gprqbiegba">{p}</p>)}
                </div>
                <p className="mt-4 rounded-2xl bg-paper p-4 text-base text-ink" data-id="element-158" data-mp="123dvn0x2hui3">
                  <strong className="text-electric" data-id="element-159" data-mp="125gjpfentdk6">The Blueprint approach:</strong> {c.approach}
                </p>
              </div>
            </li>)}
        </ol>

        <div className="mt-8 rounded-3xl bg-navy-950 px-6 py-10 text-center text-white sm:px-12 sm:py-14" data-id="element-160" data-mp="adr7vzzvtnpb">
          <p className="font-display text-3xl font-extrabold uppercase leading-tight sm:text-5xl" data-id="element-161" data-mp="od0lcrwpe3pl">
            The challenge isn’t always a lack of information.
          </p>
          <p className="mx-auto mt-4 max-w-2xl text-lg text-white/80" data-id="element-162" data-mp="1zpkya59t9crt">
            Sometimes, the real challenge is organizing the information you already have. AESTHETIC LASER
            CLINICAL BLUEPRINT™ brings related educational topics together in one collection, giving you a
            practical starting point for building a more organized professional reference library.
          </p>
        </div>

        <TransformCTA headline="Explore the complete Blueprint" label="Get The Full Collection" data-id="element-163" data-mp="2btoyh5i2il15" />
      </div>
    </section>;
}